import { baseURL } from './API';

export const systemAPI = baseURL + '/apaas-system-service/';
export const resourceAPI = baseURL + '/grt-resource-manage-service';
export const platformAPI = baseURL + '/grt-platform-manage-service';
export const engineAPI = baseURL + '/business-engine-service';
export const analysisAPI = baseURL + '/grt-resource-analysis-service';
export const aiResourceAPI = baseURL + '/grt-resource-manage-ai';
export const bbsAPI = baseURL + '/grt-bbs-service';
export const courseReviewAPI = baseURL + '/grt-course-review-service';
export const tradeAPI = baseURL + '/grt-trade-service';
export const liveAPI = baseURL + '/grt-live-service';
export const platformLiveAPI = baseURL + '/grt-live-platform-service';
export const userCenterAPI = baseURL + '/grt-user-center-service';
export const dynamicFieldAPI = baseURL + '/grt-dynamic-field-service';
export const engineConfigAPI = baseURL + '/business-engine-config-service';
export const aiAPI = baseURL + '/grt-ai';
export const dpaasAPI = baseURL + '/dpaas-data-api';
export const studyArchivesAPI = baseURL + '/grt-study-archives-service';
export const ragflowAPI = baseURL + '/grt-ragflow';
export const knowledgeAPI = baseURL + '/grt-knowledge-graph-service';
export const studentAPI = baseURL + '/grt-student-service';
export const modelAPI = baseURL + '/grt-model-service';
export const urgeLearnAPI = baseURL + '/grt-urge-learn-service';
export const applicationMarketAPI = baseURL + '/grt-application-market-service';
export const tenantManageAPI = baseURL + '/grt-tenant-manage-service';
export const userAPI = baseURL + '/grt-user-service';
export const pointAPI = baseURL + '/grt-point-service';


export default {
    systemAPI,
    resourceAPI,
    platformAPI,
    engineAPI,
    analysisAPI,
    aiResourceAPI,
    bbsAPI,
    courseReviewAPI,
    tradeAPI,
    liveAPI,
    platformLiveAPI,
    userCenterAPI,
    dynamicFieldAPI,
    engineConfigAPI,
    aiAPI,
    dpaasAPI,
    studyArchivesAPI,
    ragflowAPI,
    knowledgeAPI,
    studentAPI,
    modelAPI,
    urgeLearnAPI,
    applicationMarketAPI,
    tenantManageAPI,
    userAPI,
    pointAPI
};
